import React, { useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Grid,
  TextField,
  Switch,
  Button,
  FormControlLabel,
} from "@mui/material";
import { useNavigate } from "react-router";
import {  post,get } from 'src/services/httpClient.service';
import { authenticationService } from "src/services";
import jwtDecode from "jwt-decode";
import { useSnackbar } from "src/components/snackbar/useSnackbar";

const AddRole = () => {
  const { showSnackbar } = useSnackbar();
  const {vendorId, franchiseId} = authenticationService.getVendorFranchiseIds();

  const navigate = useNavigate();
  const [roleName, setRoleName] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState(true);
  const [loading, setLoading] = useState(false);
  const [distributorAccess, setDistributorAccess] = useState(false);

  const API_BASE_URL = process.env.REACT_APP_BASE_API_URL

  const token = localStorage.getItem("token");
  const decoded = jwtDecode(token);
  const [user,setUser] = useState<any>(decoded)
  
 console.log(vendorId,franchiseId)

  const handleSave = async () => {
  
    const currentDate = new Date().toISOString();

    // Build full payload structure
    const payload = {
      createdBy: user.userEmail,
      createdDate: currentDate,
      description: description,
      franchiseId: franchiseId,
      isActive: status,
      isDefaultRole: false,
      hasDistributorAccess: distributorAccess,
      name: roleName,
      permissions: [],
      permissionsList: [],
      updatedBy: user.userEmail,
      updatedDate: currentDate,
      userProfileId: "",
      vendorId:vendorId,
    };

    console.log("📦 Payload:", payload);
    setLoading(true);

    try {
      const response = await post(`${API_BASE_URL}/api/globalRole`,payload)

      
      console.log("✅ Response:", response);
      navigate("/Role/role");
      showSnackbar("success", "success");

    } catch (error) {
      showSnackbar("error", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/Role/role");
    setRoleName("");
    setDescription("");
    setStatus(true);
  };

  return (
    <Box
      sx={{
        backgroundColor: "#0b0f29",
        minHeight: "100vh",
        p: 4,
        color: "#fff",
      }}
    >
      <Paper
        sx={{
          p: 3,
          maxWidth: 700,
          margin: "0 auto",
          backgroundColor: "#151a36",
          borderRadius: 3,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            mb: 3,
            color: "#fff",
            pb: 1,
          }}
        >
          ➕ Add Role
        </Typography>

        <Grid container spacing={3}>
          {/* Role Name */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Role Name"
              variant="outlined"
              value={roleName}
              onChange={(e) => setRoleName(e.target.value)}
              InputLabelProps={{ style: { color: "#bbb" } }}
              InputProps={{
                style: { color: "#fff", borderColor: "#555" },
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#555" },
                  "&:hover fieldset": { borderColor: "#888" },
                  "&.Mui-focused fieldset": { borderColor: "#6a1b9a" },
                },
              }}
            />
          </Grid>

          {/* Description */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Description"
              variant="outlined"
              multiline
              rows={3}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              InputLabelProps={{ style: { color: "#bbb" } }}
              InputProps={{
                style: { color: "#fff", borderColor: "#555" },
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#555" },
                  "&:hover fieldset": { borderColor: "#888" },
                  "&.Mui-focused fieldset": { borderColor: "#6a1b9a" },
                },
              }}
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={distributorAccess}
                  onChange={(e) => setDistributorAccess(e.target.checked)}
                  color="success"
                />
              }
              label={`Has Distributor Access : ${distributorAccess ? "ON" : "OFF"}`}
            />
          </Grid>

          {/* Status Switch */}
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={status}
                  onChange={(e) => setStatus(e.target.checked)}
                  color="success"
                />
              }
              //label={status ? "Approved" : "Disabled"}
              label={`Status : ${status ? "ACTIVE" : "INACTIVE"}`}
              sx={{ color: "#fff" }}
            />
          </Grid>

          {/* Buttons */}
          <Grid item xs={12}>
            <Box display="flex" gap={2}>
              <Button
                variant="contained"
                onClick={handleSave}
                disabled={loading}
              >
                {loading ? "Saving..." : "Save"}
              </Button>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#e53935",
                  "&:hover": { backgroundColor: "#c62828" },
                  textTransform: "none",
                  px: 4,
                }}
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default AddRole;
